<template>
  <div id="ChargeSheet">
          <div class="row">
            <div class="col-12">
              <MdTitleRegInfo
                v-bind:RegistrationInfo="PatientTitle" 
                v-bind:titlePrefix="$t('ChargeSheet.EditChargeSheet')" 
                v-bind:IsClinical="false"
                v-bind:titleRef="'titleElementPatientClaim'"
                v-bind:patientCode="this.$route.params.id">
              </MdTitleRegInfo>
            </div>

            <div class="ChargeSheetContainerBox noNum mt-2">            
            <div class="row">
            <div class="col-md-12">
                <div class="grid-margin stretch-card">
                <div class="card activeCard">
                    <div class="card-body">
                    <div 
                        class="d-flex align-items-start justify-content-between">
                        <h6 v-b-toggle="'InfoBoxs'" class="card-title flex-grow lower-line text-truncate">
                          {{ $t('PatientClaimList.AditionalInformation') }}
                        </h6>
                        </div>
                        <b-collapse visible id="InfoBoxs" class="small-info ml-2"><small>{{$t('ChargeSheet.clickTitleTextChargeSheet')}}</small></b-collapse>
                    <b-collapse id="InfoBoxs"> 
                        


                        <div class="card activeCard">			
                            <div class="container-mars">
                                <div class="card-container">
                                    <div class="card-body">
                                        <div class="row patPhoto-container">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.MrNo') }}</small><br>
                                                        <b>aaaaaaaaaaaaaaa</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.AccountNo') }}</small><br>
                                                        <b>bbbbbbbbbbbbbbbbbbbbbbbbbbbb</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.AdmDate') }}</small><br>
                                                        <b>ccccccccccccccccccccccccccc</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.AdmTime') }}</small><br>
                                                        <b>dddddddddddddddddddddddddddddddd</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.DiscDate') }}</small><br>
                                                        <b>eeeeeeeeeeeeeeeeeeeeeee</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.DiscTime') }}</small><br>
                                                        <b>fffffffffffffffffffffff</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.ReferenceNo') }}</small><br>
                                                        <b>ggggggggggggggggggggggggggg</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.PatientName') }}</small><br>
                                                        <b>hhhhhhhhhhhhhhhhhhhhhhhhhh</b>
                                                    </div>                                                    
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.DaysLpf') }}</small><br>
                                                        <b>iiiiiiiiiiiiiiiiiii}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.PrimDiag') }}</small><br>
                                                        <b>jjjjjjjjjjjjjjjjjjjjjjjjj</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.RoomNumber') }}</small><br>
                                                        <b>kkkkkkkkkkkkkkkkkkkkkk</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.PatientAddress') }}</small><br>
                                                        <b>lllllllllllllllllllllllll</b>
                                                    </div>                                                    
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.DoctorName') }}</small><br>
                                                        <b>iiiiiiiiiiiiiiiiiii}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.Zip') }}</small><br>
                                                        <b>jjjjjjjjjjjjjjjjjjjjjjjjj</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.City') }}</small><br>
                                                        <b>kkkkkkkkkkkkkkkkkkkkkk</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.State') }}</small><br>
                                                        <b>lllllllllllllllllllllllll</b>
                                                    </div>                                                    
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.Age') }}</small><br>
                                                        <b>iiiiiiiiiiiiiiiiiii}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.SSN') }}</small><br>
                                                        <b>jjjjjjjjjjjjjjjjjjjjjjjjj</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.Gender') }}</small><br>
                                                        <b>kkkkkkkkkkkkkkkkkkkkkk</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.InsuranceCode') }}</small><br>
                                                        <b>lllllllllllllllllllllllll</b>
                                                    </div>                                                    
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.InsuranceCompany') }}</small><br>
                                                        <b>iiiiiiiiiiiiiiiiiii}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.PrimInsuranceNo') }}</small><br>
                                                        <b>jjjjjjjjjjjjjjjjjjjjjjjjj</b>
                                                    </div>                                                
                                                </div>
                                            </div>
                                        </div>                   
                                    </div>
                                </div>
                            </div>    
                        </div>            
                </b-collapse>
                    </div> 
                </div>                
                </div>                 
            </div>                     
            </div>                
         </div>
        </div> 

        <div class="space-actions"></div>
         <div class="page-actions">
        <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:Name="'btnpatientlist'"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="DiscardChanges"/>
        <b-dropdown id="dropdown-dropup" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2">
          <b-dropdown-item-button 
            v-on:click="onClick()">          
            Summary          
          </b-dropdown-item-button>

          <b-dropdown-item-button 
            v-on:click="onClick()">          
            Patient Actions          
          </b-dropdown-item-button>

          <b-dropdown-item-button 
            v-on:click="onClick()">          
            Reset Room Charge          
          </b-dropdown-item-button>

          <b-dropdown-item-button 
            v-on:click="onClick()">          
            Batch          
          </b-dropdown-item-button>

          <b-dropdown-item-button 
            v-on:click="onClick()">          
            Billable RP          
          </b-dropdown-item-button>

          <b-dropdown-item-button 
            v-on:click="onClick()">          
            Option          
          </b-dropdown-item-button>
        </b-dropdown>
    </div>


      <b-row>
          <b-col md="12">              
            <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/> 
              <MdTable 
                v-bind:fields="fields"
                v-bind:items="items"
                v-bind:totalRows="totalRows"
                v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                v-bind:currentPage="currentPage"
                v-bind:perPage="perPage"
                v-bind:pageOptions="pageOptions"
                v-bind:refTable="'tablePatientpostPayment'"                      
                :onRowSelected="onRowSelected"
                :onFiltered="onFiltered"
                :pageChanged="pageChanged"
                :perPageFunction="PerPageFunction">
              </MdTable>
          </b-col>
      </b-row>


  </div>
</template>

<script>
    import ChargeSheetService from '@/services/chargesheet.service'
    import ShowMessage from '@/components/messages/ShowMessage.js';
    import DBFunctions from '@/common/DBFunctions.js';
    import Utils from "@/common/utils";

    export default {
        mixins: [ShowMessage, DBFunctions],
        name: 'ChargeSheetDetail',
        data(){
        return {
          items:[],
          Header:{},
          SearchCriteria:"",
          ShowMessageIsEmpty:false,
          pageOptions: [5,10,20,30,40,50],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,            
              favButtonAtion:false          
            },

           fields: [           
            { key: 'patientcode', sortable: true, label: 'Patient Code', class: 'text-rigth' },
            { key: 'patientName', sortable: true, label: 'Patient Name', class: 'text-rigth' },
            { key: 'admitdate', sortable: true, label: 'Admit Date', class: 'text-rigth' },
            { key: 'admittime', sortable: true, label: 'Admit Time', class: 'text-rigth' },
            { key: 'dischargedate', sortable: true, label: 'Discharge Date', class: 'text-rigth' },
            { key: 'dischargetime', sortable: true, label: 'Discharge Time', class: 'text-rigth' },
            { key: 'roomno', sortable: true, label: 'Room', class: 'text-rigth' },
            { key: 'admissionsource', sortable: true, label: 'SRC', class: 'text-rigth' },            
            { key: 'admissiontype', sortable: true, label: 'Type', class: 'text-rigth' },            
            { key: 'programcode', sortable: true, label: 'Program', class: 'text-rigth' },
            { key: 'minServiceDate', sortable: true, label: 'Service Date From', class: 'text-rigth' },
            { key: 'maxServiceDate', sortable: true, label: 'Service Date To', class: 'text-rigth' },
            { key: 'company', sortable: true, label: 'Company', class: 'text-rigth' },
          ],
          showMessageIsEmpty: false,
          PatientTitle:{      
            programName:'',
            fullName:'',
            admitDate:'',
            dischargeDate:'',
            dob:'',
            activitytypename:'',
            startdatetime:'',
            ageFormatted:''
          },
        };
      },
        methods: {

          DiscardChanges() {
            this.$router.push({
              name: "chargesheet"
            });
          },

          onClick() {

          },

          async GetPatientByCode(){
            var infoList = await this.getInfoTitle(this.$route.params.id);
            if(infoList.length > 0){
              this.PatientTitle.programName = '';
              this.PatientTitle.admitDate = '';
              this.PatientTitle.dischargeDate = '';

              const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

              if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
              if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
              if (age) this.PatientTitle.age = age;
              if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;     
            }
          },

          pageChanged(page){            
            this.currentPage = page;    
            this.GetChargeSheetFilteredList();   
          },

          PerPageFunction(perpage){
            this.perPage = perpage;              
            this.currentPage = 1;   
            this.GetChargeSheetFilteredList();       
          },

          onRowSelected(){

          },

          onFiltered(){

          },

          DateFromChange(){

          },

          DateToChange(){

          },


          async GetChargeSheetFilteredList() {
                  this.$emit('load', true)
                  let params = {
                    "SearchCriteria":this.SearchCriteria,
                    "PageSize":  this.perPage,
                    "PageNumber" : this.currentPage,
                    "DateFrom": Utils.formatterToISO(this.DateFrom),
                    "DateTo": Utils.formatterToISO(this.DateTo),
                    "ProgramCode": this.ProgramModel && this.ProgramModel.code ? this.ProgramModel.code : null,
                    "Status": this.StatusModel && this.StatusModel.code ? this.StatusModel.code : null,                  
                  }                
                  await ChargeSheetService.getAll(params)
                  
                 .then((response) => {
                    if(response.status == '200'){
                        this.items = response.data; 
                        
                        let headerString = response.headers["x-pagination"];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;    

                        this.items.forEach(element => {  
                          element.admitdate = element.admitdate ? Utils.formatterDateToString(element.admitdate) : null; 
                          element.dischargedate = element.dischargedate && element.dischargedate != '0001-01-01T00:00:00'  ? Utils.formatterDateToString(element.dischargedate) : null; 
                          element.maxServiceDate = element.maxServiceDate  && element.maxServiceDate != '0001-01-01T00:00:00' ? Utils.formatterDateToString(element.maxServiceDate) : null;
                          element.minServiceDate = element.minServiceDate  && element.minServiceDate != '0001-01-01T00:00:00' ? Utils.formatterDateToString(element.minServiceDate) : null;

                          element.admittime = element.admittime ? Utils.formatTime(element.admittime) : null;
                          element.dischargetime = element.dischargetime && element.dischargetime != '0001-01-01T00:00:00' ? Utils.formatTime(element.dischargetime) : null;
                         })

                      }               
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        } 
      },
      created() {
      },

      async mounted(){
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
          case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
          case 'L1R0':
          case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
          default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        await this.GetPatientByCode();
      }
    };
</script>
